"use strict";

export const COMPLETE = "completed";
export const PENDING = "pending";
export const CANCELLED = "cancelled";

export const ASSESSMENT_DEMONSTRATED = "demonstrated";
export const ASSESSMENT_REINFORCED = "reinforced";
export const ASSESSMENT_NEEDS_ATTENTION = "needs_attention";
export const ASSESSMENT_IN_PROGRESS = "in_progress";
export const ASSESSMENT_NOT_STARTED = "not_started";
export const ASSESSMENT_NO_GOALS_AVAILABLE = "no_goals_available";
export const ASSESSMENT_NOT_REQUIRED = "not_required";
export const OBJECTIVES_PENDING = "pending";
export const OBJECTIVES_READY = "ready";
export const OBJECTIVES_NOT_STARTED = "not_started";
export const ASSESSMENT_OBJECTIVE_DRAFT = "draft";

export const GROWER_CERTIFIED = "grower";
export const SELF_CERTIFIED = "self";

export const SAFETY_MEETING = "safetymeeting";
export const GENERAL_TRAINING = "general";

export const FAIL = "fail";
export const PASS = "pass";

export const STATIC = "static";
export const DYNAMIC = "dynamic";
export const FARM_CONTINUING_EDUCATION = "farm_ce";

export const ACCIDENT_REPORT_SOFT_REQUIRED_FIELDS = [
    "accident_location",
    "before_accident_description",
    "what_happened_description",
    "affliction_description",
    "accident_date",
    "time_employee_began_work",
    "accident_classification",
    "employee_job_title",
];
